import { BaseModel } from "model/BaseModel";
import HorarioDia from "./HorarioDia";
import { BaseEditModel } from "model/BaseEditModel";

export default class HorarioDiaItem implements BaseEditModel {
    id: number;
    codigo: string | null = null;
    sequencial: number | null = null;
    key: string | null = "";
    horaInicio: number;
    horaFim: number;
    horarioDia: HorarioDia|null;

    constructor(
        id = 0, 
        horaInicio = 0, 
        horaFim = 0,
        horarioDia = null
    ) {
        this.id = id;
        this.horaInicio = horaInicio;
        this.horaFim = horaFim;
        this.horarioDia = horarioDia;
    }
    
}